import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupUser, EditUser } from '../models/user';
import { errorlist } from '../providers/errorlist';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
import {COUNTRY} from '../providers/country';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {
  userData:EditUser = {first_name: null, last_name: null, email: null, area_id: null, country_code: '+1', phone: null, street_address: null, apt: null, cross_street: null }
  areaData:any = [];
  public editprofile: SignupUser;
  errorlist:any;
  currentUser:any = {};
  country : any;
  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { 
    this.country = COUNTRY;
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

    this.editprofile = {
      first_name:"",
      last_name:"",
      email: "", 
      area_id:null,
      phone:"",
      password: "", 
      street_address:"",
      apt:"", 
      cross_street:"", 
      term:0
    }
    //assign all errorlist in 
    this.errorlist = errorlist;

    this.spinnerService.show();
    let sid = localStorage.getItem('sid');
    this.auth.getarea().then((area) => {
      let response = area.json();
      if(response.replyCode == "error"){
        console.log("error with get area")
      }else{
        this.areaData = response.data;
        console.log("areaData", this.areaData)
        this.auth.my_account({"sid":sid}).then((user) => {
          console.log(user.json());
          let response = user.json();
          if(response.replyCode == "error"){
            this.spinnerService.hide();
            this.auth.open(response.replyMsg);
          }else{
            this.userData = user.json().data;
            this.spinnerService.hide();
            console.log("userData", this.userData)
          }
        })
        .catch((err) => {
          this.spinnerService.hide();
          console.log(err);
          this.auth.open(environment.error)
        });
        
      }
    })
    .catch((err)=>{

    });

    
  }

  lat;
  lng;
  location;
  userSettings = {
    "showCurrentLocation":false,
    "showSearchButton":false,
  }
  autoCompleteCallback1(selectedData:any) {
    //do any necessery stuff.
    ///console.log(selectedData);
    let geometry = selectedData.data.geometry;
    //console.log(geometry);
    if ((geometry) !== undefined) {  
      this.lat = geometry.location.lat;
      this.lng = geometry.location.lng;
    }
    this.location = selectedData.data.description; 
    //console.log('lat = '+this.lat,'lat = '+this.lng,'lat = '+this.location);
  }

  editProfileUser(){
    this.spinnerService.show();
    let sid = localStorage.getItem('sid');
    this.userData['sid'] = sid;

    this.userData['lat'] = this.lat;
    this.userData['lng'] = this.lng;
    this.userData['location'] = this.location;

    console.log(this.userData)
    this.auth.edit_profile(this.userData).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.userData = user.json().data;
        localStorage.setItem("currentUser", JSON.stringify(user.json().data));
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
        this.router.navigateByUrl('view-profile');
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
   this.router.navigate(['/']);
 }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/edit-profile/edit-profile.component.ts